import PocketBase from "pocketbase";
import { config } from "../config/env";

// Create PocketBase instance with specific options
export const pb = new PocketBase(config.baseUrl);
